import { render, staticRenderFns } from "./LeaveMsg.vue?vue&type=template&id=165da0f4&"
import script from "./LeaveMsg.vue?vue&type=script&lang=js&"
export * from "./LeaveMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports